import { Routes } from '@angular/router';
import { AccessMessageComponent } from '../pages/access-message/access-message.component';
import { LoginComponent } from '../pages/login/login.component';
import { AuthGuard } from '../services/auth-guard.service';

export const routes: Routes = [
  { path: '', loadChildren: () => import('../pages/transporter/transporter.module').then(m => m.TransporterModule), canActivate: [AuthGuard] },
  { path: 'access', component: AccessMessageComponent },
  { path: 'login', component: LoginComponent },
  { path: '**', redirectTo: '' }
];
